<form class="app-grid" #form="ngForm">
    <div class="info-access">
        <label role="button" [class.disabled]="role.isImmutable" class="flex" (click)="openSelect(employeeAccessMenu)">
            {{ 'settings.role-permissions.canAccessInfoForLabel' | appTranslate }}
            <span class="font-bold">
                &nbsp;{{ employeeAccessLevel | appTranslate }}
                <mat-icon svgIcon="chevronDown"></mat-icon>
            </span>
        </label>
        <mat-select
            #employeeAccessMenu
            [(ngModel)]="employeeAccessLevel"
            (ngModelChange)="onAccessLevelChange($event)"
            class="hidden"
            name="employeeAccessMenu"
            aria-hidden="true"
            panelClass="top-space"
            [disabled]="role.isImmutable"
            disableOptionCentering
        >
            <mat-option *ngFor="let level of ACCESS_LEVELS | keyvalue" [value]="level.value">
                {{ level.value | appTranslate }}
            </mat-option>
        </mat-select>
    </div>
    <div class="self" *ngIf="employeeAccessLevel === ACCESS_LEVELS.onlySelf">
        <ui-card variant="outline">
            <app-segment-header
                title="{{ 'settings.role-permissions.basicAccessHeading' | translate }}"
            ></app-segment-header>
            <p [innerHTML]="'settings.role-permissions.basicAccessMessage' | translate"></p>
        </ui-card>
    </div>

    <div class="content" *ngIf="employeeAccessLevel !== ACCESS_LEVELS.onlySelf">
        <app-tab-bar class="margin-top-3 margin-bottom-2" [menuService]="menuService" />
        <div class="app-grid">
            <div class="columns-7">
                <div class="set-all">
                    <label
                        role="button"
                        class="flex"
                        [class.disabled]="role.isImmutable"
                        (click)="openSelect(setFieldSelect)"
                    >
                        {{ 'settings.role-permissions.setAllFieldsToLabel' | translate }}
                        <span class="font-bold">
                            &nbsp;{{ FIELD_LEVELS[appliedAllFields] | translate }}
                            <mat-icon svgIcon="chevronDown"></mat-icon>
                        </span>
                    </label>
                    <mat-select
                        #setFieldSelect
                        class="hidden"
                        (selectionChange)="onSetAllFields($event.value)"
                        [disabled]="role.isImmutable"
                    >
                        <mat-option *ngFor="let level of FIELD_LEVELS | keyvalue" [value]="level.key">
                            {{ level.value | translate | titlecase }}
                        </mat-option>
                    </mat-select>
                </div>

                <ng-container [ngSwitch]="tab">
                    <ng-container *ngFor="let profileTab of profilePermissions">
                        <ng-container *ngSwitchCase="profileTab.tab">
                            <app-segment-header [title]="profileTab.title"></app-segment-header>
                            <div
                                *ngFor="let segment of profileTab.segments"
                                class="segmentPermissions flex margin-bottom-2 padding-bottom-2"
                            >
                                <div [class.segment-nest]="segment.nest">{{ segment.label | translate }}</div>
                                <div class="permissions flex" [class.disabled]="role.isImmutable">
                                    <button
                                        [disabled]="role.isImmutable"
                                        (click)="segment.level = null"
                                        [matTooltip]="'settings.role-permissions.noAccessTooltip' | translate"
                                    >
                                        <mat-icon svgIcon="lock" [color]="!segment.level && 'primary'"></mat-icon>
                                    </button>
                                    <button
                                        role="button"
                                        [disabled]="role.isImmutable"
                                        (click)="segment.level = 'view'"
                                        [matTooltip]="'settings.role-permissions.canViewTooltip' | translate"
                                    >
                                        <mat-icon
                                            svgIcon="visibilityEnabled"
                                            [color]="segment.level === 'view' && 'primary'"
                                        ></mat-icon>
                                    </button>
                                    <button
                                        role="button"
                                        [disabled]="role.isImmutable"
                                        (click)="segment.level = 'edit'"
                                        [matTooltip]="'settings.role-permissions.canEditTooltip' | translate"
                                    >
                                        <mat-icon
                                            svgIcon="edit"
                                            [color]="segment.level === 'edit' && 'primary'"
                                        ></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div class="columns-4-end">
                <ui-card variant="outline">
                    <app-segment-header
                        title="{{ 'settings.role-permissions.whatArePermissionLevelsHeading' | translate }}"
                    ></app-segment-header>
                    <p>{{ 'settings.role-permissions.whatArePermissionLevelsMessage' | translate }}</p>
                </ui-card>
            </div>
        </div>
    </div>
</form>
